import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'

import {
	Validator
} from 'vee-validate'

export default {
	name: 'Packingreport',
	components: {
		//	Paginate,
		Pagination,
		DatePicker,
		download,
		Loader
	},
	data: function() {
		return {
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			listReceviedEmailData: [],
			listRecordsData: [],
			listWarehouseData: [],
			// pageno: 0,
			// pageCount: 0,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			isLoading: false,
			searchFlag: false,
			loginwarehouseid: '',
			Warehouse_obj: '',
			emailfromdate: '',
			emailtodate: '',
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			addemailreceivedmodal: false,
			closeaddemailreceivedmodal: false,
			linkflag: false,
			user_type: '',
			emailsender: '',
			Subject: '',
			Subjectedit: '',
			createddatetime: '',
			emaildatetime: '',
			useremail: '',
			id: '',
			excelfilename: '',
			operation: '',
			clientname: '',
			totalrecords: '',
			newreocrds: '',
			updatedrecords: '',
			faliedrecords: '',
			rejectreason: '',
			QCstatus: '',
			downloadlink: '',
			cancelfilename: '',
			cancelfilepath: '',
			invalidFlag: '',
			actualSubject: '',
			errorMessage: '',
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
			// this.getReceviedEmailData();/
		}
		this.user_type = userdetail.utype;

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		closeaddemailreceived() {
			this.addemailreceivedmodal = false;
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {

		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.totalRows = 0
		// 		this.listReceviedEmailData = []
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			// this.getReceviedEmailData();
		// 		}
		// 	}

		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.listReceviedEmailData = []
		// 	this.totalRows = 0;
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getReceviedEmailData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getReceviedEmailDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined') {
				this.ClientErr = this.$t('common.clientError');
				this.$alertify.error(this.ClientErr)
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.$alertify.error(this.WarehouseErr)
				return false;
			}
			this.getReceviedEmailData();
		},
		getReceviedEmailData() {
			this.searchFlag = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var emailto_date = '';
			var emailfr_date = '';

			this.isLoading = true;

			if (this.emailfromdate == '') {
				emailfr_date = '';
			} else {
				emailfr_date = this.dateFormat(this.emailfromdate)
			}

			if (this.emailtodate == '') {
				emailto_date = '';
			} else {
				emailto_date = this.dateFormat(this.emailtodate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromdate: this.dateFormatFRT(emailfr_date),
				todate: this.dateFormatFRT(emailto_date),
				useremail: this.emailsender.trim(),
				subject: this.Subject.trim(),
				clientid: localStorage.getItem("selectedClient"),
				qc: this.QCstatus
				// warehouseid: this.warehouseid
			})

			axios({
					method: 'POST',
					'url': 'http://35.154.4.29/getEmailData',
					'data': this.input,
					headers: {
						//'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listReceviedEmailData = result.data.data;

					if (result.data.errorCode == -1) {
						this.resultCount = 0;
						this.totalRows = 0;
					} else {
						this.totalRows = parseInt(result.data.totalCount);
						this.resultCount = result.data.totalCount
						if (this.totalRows < 10) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / 10)
						}
					}
					this.isLoading = false;

				}, error => {
					console.error(error)
				})
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},

		resetForm() {
			this.totalRows = 0;
			this.Subject = '';
			this.emailsender = '';
			this.emailfromdate = '';
			this.emailtodate = '';
			this.QCstatus = '';
			this.listReceviedEmailData = [];
			this.currentPage = 1;
			this.searchFlag = false;
			// this.getReceviedEmailData();
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},
		getemailsdetails(data) {

			if (data.operation != 'invalid' & data.csvstatus == 0) {
				this.$alertify.error(this.$t('receivedEmail.emailNotProcessed'));
				return false;
			} else {
				this.addemailreceivedmodal = true;
				this.$validator.reset();
				this.errors.clear();
				this.createddatetime = data.createddatetime;
				this.emaildatetime = data.emaildatetime;
				this.useremail = data.useremail;
				this.actualSubject = data.emailsubject;
				if (data.rejectreason != null && data.rejectreason == "Subject Is Invalid") {
					this.Subjectedit = "Invalid Subject For Data Upload";
					this.errorMessage = this.$t('receivedEmail.emailSubjectError');
				}
				if (data.rejectreason != null && data.rejectreason != "Subject Is Invalid") {
					this.Subjectedit = "Invalid Attachment Found For Data Upload";
					this.errorMessage = this.$t('receivedEmail.emailAttachmentError');
				}
				if (data.rejectreason == null) {
					if (data.operation == "po") {
						this.Subjectedit = "Po Upload Report";
					} else {
						this.Subjectedit = "Product Upload Report";
					}

					this.errorMessage = "";
				}

				this.id = data.id;
				this.excelfilename = data.excelfilename;
				this.operation = data.operation;
				if (data.clientid == '1004') {
					this.clientname = 'Aceturtle'
				}
				if (data.clientid == '1005') {
					this.clientname = 'Miniso'
				}
				if (data.clientid == '1006') {
					this.clientname = 'Ibell'
				}
				if (data.clientid == '1007') {
					this.clientname = 'Bewkoof'
				}
				if (data.clientid == '1008') {
					this.clientname = 'Demo'
				}
				if (data.clientid == '1009') {
					this.clientname = 'Inzpera'
				}


				this.newreocrds = data.addquantity;
				this.updatedrecords = data.modifiedquantity;
				this.faliedrecords = data.rejectquantity;
				this.rejectreason = data.rejectreason;
				this.cancelfilename = data.cancelfilename;
				this.cancelfilepath = data.cancelfilepath;
				this.totalrecords = parseInt(this.newreocrds) + parseInt(this.updatedrecords) + parseInt(this.faliedrecords);
				this.linkflag = false;
				if (this.faliedrecords > '0') {
					this.linkflag = true
					var temp = this.cancelfilepath.split('/');
					this.cancelfilepath = temp[4] + '/' + temp[5] + '/' + temp[6] + '/' + temp[7] + '/' + temp[8];
					this.downloadlink = 'http://35.154.4.29/' + this.cancelfilepath + '/' + this.cancelfilename
				}
			}

		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormatFRT2(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY  HH:mm:ss');
		},

		//to paginate  GRC List
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getReceviedEmailData()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getReceviedEmailData()
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/receivedemail/receivedemail.component.js